module.exports = __webpack_public_path__ + "static/media/magnifying-glass.d833f949.svg";